import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLayoutPreferences } from '@/contexts/LayoutPreferencesContext';
import { cn } from '../ui/utils';
import NexusBreadcrumb from './NexusBreadcrumb';
import RecentPages from './RecentPages';

type NavChromeProps = {
    pageTitle?: string;
};

export default function NavChrome({ pageTitle }: NavChromeProps) {
    const { preferences, setNavChromeCollapsed: setCollapsed } = useLayoutPreferences();
    const collapsed = preferences.navChromeCollapsed;

    return (
        <div
            data-tour="nav-chrome"
            className={cn('nx-nav-chrome', collapsed && 'nx-nav-chrome--collapsed')}
            data-collapsed={collapsed ? 'true' : 'false'}
        >
            <div className="nx-nav-chrome-body" aria-hidden={collapsed} inert={collapsed ? true : undefined}>
                <RecentPages pageTitle={pageTitle} />
                <div className="nx-nav-chrome-row">
                    <NexusBreadcrumb />
                    <button
                        type="button"
                        className="nx-nav-chrome-toggle nx-icon-btn nx-icon-btn--sm"
                        aria-label="Ocultar atalhos e caminho"
                        title="Ocultar atalhos e caminho"
                        tabIndex={collapsed ? -1 : 0}
                        onClick={() => setCollapsed(true)}
                    >
                        <ChevronUp size={16} strokeWidth={2.2} aria-hidden />
                    </button>
                </div>
            </div>

            <button
                type="button"
                className="nx-nav-chrome-expand"
                aria-label="Mostrar atalhos e caminho"
                title="Mostrar atalhos e caminho"
                tabIndex={collapsed ? 0 : -1}
                aria-hidden={!collapsed}
                onClick={() => setCollapsed(false)}
            >
                <ChevronDown size={15} strokeWidth={2.2} aria-hidden />
                <span>Mostrar atalhos e caminho</span>
            </button>
        </div>
    );
}
